import {client} from '../helpers/api';

export async function postCreateOnlinePayment({
  image,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  monthNumber,
}) {
  const body = new FormData();
  body.append('kid_id', kidId);
  body.append('package_id', packageId);
  body.append('subject_names', subjectNames);
  body.append('month_number', monthNumber);
  if (selectedTimeTable) {
    try {
      const scheduleData = JSON.stringify(
        convertTimeTableData(selectedTimeTable),
      );
      body.append('schedule_data', scheduleData);
    } catch (error) {
      console.log(
        '🚀 ~ file: postCreateManualPayment.js ~ line 56 ~ error',
        error,
      );
    }
  }
  if (renewData) {
    body.append('price_per_subject', renewData.pricePerSubject);
    body.append('no_of_subject', renewData.noOfSubject);
    body.append('total_price', renewData.totalPrice);
  }

  const response = await client.post('/api/create-invoice', body, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  if (response.data?.status) {
    return response.data?.invoice_url || '';
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}

function convertTimeTableData(selectedTimeTable) {
  return selectedTimeTable.reduce((acc, {scheduleId, weekDay}) => {
    const dayObject = acc.find(({week_day}) => week_day === weekDay);
    if (dayObject) {
      dayObject.schedules.push(scheduleId);
      const newRes = acc.map((item) =>
        item.week_day === weekDay ? dayObject : item,
      );
      return newRes;
    } else {
      const newDayObject = {
        week_day: weekDay,
        schedules: [scheduleId],
      };
      const newRes = [...acc, newDayObject];
      return newRes;
    }
  }, []);
}
